<template>
    <div class="rr-progress-bar">
        <div class="rr-progress-bar__summary">
            <p class="title progress-bar__title">
                {{ $t('rubinred.ecommerce.orders.checkout.step-1.title') }}
            </p>
            <p class="rr-progress-bar__text">
                {{ cart.items.length }} {{ $t('rubinred.ecommerce.orders.checkout.article') }} -
                <strong>{{ Utils.Currencies.toHuman(cart.total) }}</strong>
            </p>
        </div>
        <ul class="rr-progress-bar__nav uk-flex-center">
            <li v-for="({icon, label}, index) in progressSteps" :class="{'uk-active': (index <= step-1)}">
                <div class="rr-progress-bar__nav-icon">
                    <i :class="icon"></i>
                </div>
                <span class="rr-progress-bar__nav-label">{{ label }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
  import CartAwareComponent from 'rubinred/ecommerce/js/mixins/CartAwareComponent'

  export default {
    mixins: [CartAwareComponent],
    props: {
      steps: {
        type: Array,
        required: true,
      },
      step: {
        type: Number,
        required: true,
      },
    },
    computed: {
      progressSteps() {
        return this.steps.map(step => step.getPreview());
      }
    },
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/checkout/partials/RubinredCheckoutProgressBar.vue